import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-tag",
    styleUrls: ["./tag.component.scss"],
    templateUrl: "./tag.component.html",
    standalone: false
})
export class FUITagComponent {
    @Input() title: string;

    constructor() {

    }
}
